import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import * as React from 'react';
import CitizenshipAttachments from './Citizenship/attatchments';
import CovidReliefAttachments from './CovidRelief/attatchments';
import DependentsAttachments from './Dependents/attatchments';
import FamilyAttachments from './Family/attatchments';
import LogisticsAttachments from './Logistics/attatchments';
import PastFillingsAttachments from './PastFillings/attatchments';

export interface ITheBasicsAttachmentsProps {}

export default function TheBasicsAttachments(
  props: ITheBasicsAttachmentsProps,
) {
  return (
    <div>
      <DashboardContainerHeader title="Personal Details / The Basics" />
      <CitizenshipAttachments />
      <CovidReliefAttachments />
      <DependentsAttachments />
      <FamilyAttachments />
      <LogisticsAttachments />
      <PastFillingsAttachments />
    </div>
  );
}
